module.exports = __webpack_public_path__ + "static/media/landscape.d9c87d3c.jpg";